import React, { useState, useEffect } from 'react';

interface DeadlineTimerProps {
  deadline: Date;
  submittedTodayCount?: number;
  totalCount?: number;
}

const DeadlineTimer: React.FC<DeadlineTimerProps> = ({ deadline, submittedTodayCount = 0, totalCount = 0 }) => {
  const [timeLeft, setTimeLeft] = useState<{
    days: number;
    hours: number;
    minutes: number;
    seconds: number;
  }>({ days: 0, hours: 0, minutes: 0, seconds: 0 });

  useEffect(() => {
    const calculateTimeLeft = () => {
      const difference = deadline.getTime() - new Date().getTime();
      
      if (difference > 0) {
        setTimeLeft({
          days: Math.floor(difference / (1000 * 60 * 60 * 24)),
          hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
          minutes: Math.floor((difference / 1000 / 60) % 60),
          seconds: Math.floor((difference / 1000) % 60),
        });
      } else {
        setTimeLeft({ days: 0, hours: 0, minutes: 0, seconds: 0 });
      }
    };

    calculateTimeLeft();
    const timer = setInterval(calculateTimeLeft, 1000);

    return () => clearInterval(timer);
  }, [deadline]);

  return (
    <div className="mb-8 flex gap-8">
      <div className="flex-1 border border-neutral-300 p-4">
        <div className="text-xs font-mono text-neutral-500 mb-2">next submission deadline</div>
        <div className="font-mono text-2xl text-neutral-900">
          {timeLeft.days}d {timeLeft.hours.toString().padStart(2, '0')}h {timeLeft.minutes.toString().padStart(2, '0')}m {timeLeft.seconds.toString().padStart(2, '0')}s
        </div>
      </div>
      <div className="border border-neutral-300 p-4">
        <div className="text-xs font-mono text-neutral-500 mb-2">submitted today</div>
        <div className="font-mono text-2xl text-neutral-900">
          {submittedTodayCount}/{1}
        </div>
      </div>
    </div>
  );
};

export default DeadlineTimer;
